import { render } from "./404.vue?vue&type=template&id=f44ab922&scoped=true&ts=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=f44ab922&lang=less&scoped=true"

import exportComponent from "E:\\pc\\hifan-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44ab922"]])

export default __exports__